import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";

const TypeFormsInstanceDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
  inputType: string;
}> = ({ options, inputType }) => {
   const FormsInstanceActiveTypeOptions = [
    { label: "Ativo", value: true },
    { label: "Inativo", value: false },
  ];

  const FormsInstanceIsAnonymousTypeOptions = [
    { label: "Sim", value: true },
    { label: "Não", value: false },
  ];

  return (
    <Dropdown
      value={options.value}
      options={inputType === "active" ? FormsInstanceActiveTypeOptions : FormsInstanceIsAnonymousTypeOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o tipo"
      showClear
    />
  );
};
export default TypeFormsInstanceDropdown;